module.exports = __webpack_public_path__ + "files/b40092f742715ad203dbbfaa37602688.woff";


//////////////////
// WEBPACK FOOTER
// ./non_npm_dependencies/google-fonts/fonts/open-sans-v13-latin-ext_latin_cyrillic-ext_greek-ext_greek_cyrillic_vietnamese-800.woff
// module id = 728
// module chunks = 60